export default {
  inviteFriendReport: {
    total: "合计",
    depth: { root: "顶级好友", level: "{{level}} 级好友" },
    scope: { root: "整条线", inviter: "直邀好友（直属一层）", member: "本人" },
    scopeDirect: "直属数据",
    rowType: { context: "所属链路的顶级好友（上下文行）", hit: "命中用户" },
    filter: {
      account: "用户账号",
      tag: "用户标签",
      tagPlaceholder: "如「推广专员」",
      currency: "币种",
      range: "统计时间区间",
      agent: "归属代理",
      agentAll: "全部",
      agentUnassigned: "未分配"
    },
    column: {
      member: "用户",
      scope: "层级 · 统计范围",
      agentAccount: "归属代理",
      date: "日期",
      inviteMemberCount: "区间邀请人数",
      directInviteCount: "区间直邀人数",
      firstDepositMemberCount: "首充人数",
      firstDepositAmount: "首存金额",
      depositTimes: "存款次数",
      depositAmount: "存款金额",
      withdrawTimes: "提款次数",
      withdrawAmount: "提款金额",
      validBetAmount: "有效投注",
      ggrAmount: "GGR",
      bonusAmount: "领取优惠(含佣金)",
      commissionAmount: "其中：邀请返佣",
      pointExchangeCash: "积分兑换现金",
      directFriend: "直邀好友",
      selfDepositAmount: "本人存款金额",
      selfWithdrawAmount: "本人提款金额",
      selfValidBetAmount: "本人有效投注",
      selfGgrAmount: "本人 GGR",
      selfBonusAmount: "本人领取优惠(含返佣)",
      selfCommissionAmount: "本人邀请返佣",
      selfPointExchangeCash: "本人积分兑换",
      trendInviteMember: "邀请用户",
      trendFirstDepositMember: "邀请首充用户",
      action: "操作"
    },
    action: { view: "查看" },
    breadcrumb: { back: "返回列表", list: "用户汇总列表" },
    composition: { rest: "其余下级合计（二级及更深，未逐人归属）", total: "合计（= 整条线 = 指标卡）" },
    analysis: {
      title: "{{account}} 的邀请分析",
      directFriends: "直邀好友构成（行 = 该好友本人数据 · 「查看」看其直属产出）",
      trendTitle: "时间趋势（{{scope}} · 逐日）",
      trendHint: "逐日展示；日期范围随顶部「统计时间区间」；合计行 = 区间总计（看某周 / 某月总量 = 把区间选为该周 / 该月）。",
      inviterScopeHint: "不含该用户本人，本人数据看上级页的构成行"
    },
    tip: {
      needCurrencyAndRange: "请先选择币种与统计时间区间",
      searchMixed: "搜索到非顶级用户：上一行是其所属链路的顶级好友（整条线），下一行是该用户的直属数据。两种口径不能相加，合计已隐藏。"
    }
  },

  comprehensiveReport: {
    title: "综合报表",
    profit: "盈利",
    profitRate: "盈利率",
    totalBet: "总投注额",
    validBet: "有效投注额",
    betUsers: "投注人数",
    onlineUsers: "在线人数",
    onlineUsersTooltip: "实时在线人数，不随筛选条件变化",
    gameProfitLoss: "游戏盈亏",
    memberBalance: "会员余额",
    deposit: "充值金额",
    totalDeposit: "充值总额",
    withdrawal: "提现金额",
    totalWithdrawal: "提现总额",
    userStatistics: "用户数据统计",
    bettingStatistics: "投注数据",
    bettingOrders: "投注单量",
    monthlyComparison: "月度对比",
    thisMonthProfit: "本月盈利",
    thisMonthProfitRate: "本月盈率",
    lastMonthProfit: "上月盈利",
    lastMonthProfitRate: "上月盈率",
    registeredUsers: "注册人数",
    firstDepositUsers: "首充人数",
    secondDepositUsers: "二充人数",
    thirdDepositUsers: "三充人数",
    memberCount: "会员余额",
    users: "人",
    depositTransactions: "充值笔数",
    withdrawalTransactions: "提现笔数",
    manualWithdrawal: "人工提现",
    countedWithdrawal: "计入提现",
    uncountedWithdrawal: "不计入提现",
    rejectedWithdrawal: "拒绝金额",
    totalPromo: "活动金额总计",
    paymentMethods: {
      bankCard: "银行卡",
      gcash: "Gcash",
      paymaya: "PAYmaya",
      manualDeposit: "人工存款",
      countedDeposit: "计入存款",
      uncountedDeposit: "不计入存款",
      promo1: "优惠礼金",
      promo2: "VIP礼金",
      promo3: "积分兑换"
    },
    withdrawalMethods: {
      bankCard: "银行卡",
      gcash: "Gcash",
      paymaya: "PAYmaya"
    },
    vipWeeklySalary: "VIP周俸禄",
    vipMonthlySalary: "VIP月俸禄",
    vipBirthdayBonus: "VIP生日礼金",
    vipUpgradePoints: "VIP升级积分",
    vipRetentionPoints: "VIP保级积分",
    vipAppDailyPoints: "VIPapp每日积分",
    vipH5DailyPoints: "VIPh5每日积分",
    vipUpgradeBonus: "VIP升级礼金",
    vipRetentionBonus: "VIP保级礼金",
    actManualBonus: "人工发放优惠",
    actRealtimeRebateBonus: "VIP游戏返水奖励",
    actRegisterBonus: "注册优惠",
    actRebateBonus: "返水奖励",
    Manual: "手工调帐",
    Bank: "银行",
    detail: "查看明细",
    amount: "金额",
    search: "搜索",
    reset: "重置",
    today: "今天",
    yesterday: "昨天",
    startDate: "开始日期",
    endDate: "结束日期",
    registerCount: "注册人数",
    depositCount: "充值人数",
    withdrawCount: "提现人数",
    betCount: "投注人数",
    firstDepositCount: "首充人数",
    chart: "图表",
    table: "报表",
    noData: "暂无数据",
    day: "日期",
    dataTip: "温馨提示：（当天统计数据可能会延迟一个小时，如果非当天数据，则是每天23:59:59快照的数据）",
    dateRangeExceeded: "自定义时间最大跨度不能超过31天",
    pointExchange: "积分兑换",
    cashExchange: "现金兑换",
    physicalExchange: "实物兑换",
    toolExchange: "道具兑换",
    exchangeMemberCount: "人数",
    exchangeQuantity: "数量",
    exchangeAmount: "金额",
    exchangeTotal: "合计",
    adjustIncrease: "调账额度：增加",
    adjustDecrease: "调账额度：减少",
    backendToAgentAdjust: "后台账户给代理调账",
    agentAdjust: "代理调账",
    adjustTransactions: "分配笔数"
  },
  regionChoropleth: {
    panelTitle: "地区分布（{country}）",
    panelHint: "点击地区可定位地图",
    legendTitle: "图例（人数）",
    countries: {
      PH: "菲律宾地区",
      VN: "越南地区",
    },
  },
  activeUserDistribution: {
    title: "活跃用户面板",
    filters: {
      timeRange: "时间范围",
      timeRangeRequired: "请选择时间范围",
      currency: "币种",
      currencyRequired: "请选择币种",
      currencyPlaceholder: "请选择币种",
      countryAll: "全部",
    },
    actions: {
      search: "查询",
      reset: "重置",
    },
    cards: {
      dailyTrend: "活跃用户趋势",
      agentDistribution: "活跃用户代理分布",
      deviceDistribution: "活跃用户设备分布",
      mobileProviderDistribution: "活跃用户运营商分布",
      depositDistribution: "活跃用户充值分布",
      regionDistribution: "地区分布",
    },
    regionTable: {
      country: "国家",
      province: "省份",
      city: "城市",
      total: "人数",
    },
    labels: {
      activeUserCount: "活跃用户数",
      noData: "暂无数据",
      noRegionData: "暂无地区数据",
      noCityData: "暂无城市数据",
      total: "总活跃用户数",
      unknown: "未知",
      agentUnknown: "代理类型 {id}",
    },
    agentTypes: {
      official: "官网",
      agent: "代理",
      adEntry: "广告入口",
      activity: "活动",
    },
    devices: {
      all: "全部",
      androidApp: "Android APP",
      androidPwa: "Android PWA",
      androidH5: "Android H5",
      iosApp: "IOS APP",
      iosPwa: "iOS PWA",
      iosH5: "iOS H5",
      web: "Web",
      others: "其他",
    },
    mobileProviders: {
      smart: "Smart",
      globe: "Globe",
      dito: "DITO",
    },
    depositStatus: {
      firstDeposit: "首充",
      repeatDeposit: "复充",
      noDeposit: "未充值",
    },
    regionMap: {
      title: "地区分布（PH省份地图）",
      provinceMapLabel: "省份地图",
      columns: {
        region: "地区",
        users: "人数",
      },
      summary: {
        coverage: "{count} 个地区上报",
      },
    },
  },
  userRegisterDistribution: {
    title: "注册用户面板",
    filters: {
      timeRange: "注册时间",
      timeRangeRequired: "请选择注册时间",
      agentType: "代理类型",
      agentTypePlaceholder: "请选择代理类型",
      loginChannel: "登录终端",
      loginChannelPlaceholder: "请选择登录终端",
      currency: "币种",
      currencyPlaceholder: "请选择币种",
      countryAll: "全部",
      mobileProvider: "运营商",
      mobileProviderPlaceholder: "请选择运营商",
      depositStatus: "充值状态",
      depositStatusPlaceholder: "请选择充值状态"
    },
    actions: {
      search: "查询",
      reset: "重置"
    },
    loginChannels: {
      all: "全部",
      androidApp: "Android APP",
      androidPwa: "Android PWA",
      androidH5: "Android H5",
      iosApp: "IOS APP",
      iosPwa: "iOS PWA",
      iosH5: "iOS H5",
      web: "Web",
      others: "其他"
    },
    depositStatus: {
      all: "全部状态",
      firstDeposit: "首充用户",
      repeatDeposit: "复充用户",
      noDeposit: "未充值用户"
    },
    cards: {
      dailyTrend: "注册人数趋势",
      registerSource: "注册来源分布",
      loginChannel: "登录终端分布",
      depositStatus: "充值状态分布",
      mobileProvider: "注册用户运营商分布",
      regionDistribution: "地区分布"
    },
    regionTable: {
      country: "国家",
      province: "省份",
      city: "城市",
      total: "注册人数"
    },
    labels: {
      registerCount: "注册人数",
      noData: "暂无数据",
      noRegionData: "暂无地区数据",
      noCityData: "暂无城市数据",
      total: "总注册人数",
      unknown: "未知",
      agentUnknown: "代理类型 {id}"
    },
    agentFallback: "未知代理类型",
    fetchAgentFailed: "获取代理类型列表失败",
    regionMap: {
      title: "地区热点地图",
      countryPlaceholder: "选择国家",
      noData: "暂无地图数据",
      notSupported: "暂不支持该国家的地图展示",
      loadFailed: "地图数据加载失败",
      loadFailedWithFallback: "无法自动下载地图，请将 GeoJSON 文件放在 {fallback} 或配置可访问的镜像",
      accessDenied: "地图数据请求被拒绝，请经由后端代理或更换数据源",
      tooltipRegion: "地区",
      provinceMapLabel: "省份地图",
      columns: {
        region: "地区",
        users: "人数"
      },
      viewCities: "查看城市",
      summary: {
        title: "热点概览",
        total: "注册总量",
        average: "单省平均",
        peak: "最高热度",
        low: "最低热度",
        topRegions: "热点地区",
        coverage: "{count} 个地区上报"
      }
    }
  },
  betRecordReportList: {
    title: "投注记录查询",
    prompt: "(除了时间筛选外,至少填写一项查询条件)",
    memberAccount: "会员账号",
    orderNumber: "订单号",
    betNumber: "投注单号",
    betDetails: "下注详情",
    payoutAmount: "派彩金额",
    profitLossChange: "盈亏变动",
    betSlipStatus: "注单状态",
    settlementVersion: "结算版本",
    repeatSettlement: "重复结算",
    transferBetSlip: "转结注单",
    gameName: "游戏名称",
    gameCode: "游戏编码",
    actions: "操作",
    details: "详情",
    matchStartTime: "开赛时间",
    isLive: "是否滚球",
    leagueName: "联赛名称",
    betMarket: "下注盘口",
    betOdds: "下注赔率",
    parlayType: "串关类型",
    settled: "已结算",
    unsettled: "未结算",
    yes: "是",
    no: "否",
    gameType: "游戏类型",
    betTime: "下注时间",
    settlementTime: "结算时间",
    settlementTimeFilter: "结算时间筛选",
    detailTitle: "体育注单详情",
    basicInfo: "基础信息",
    betContent: "下注内容",
    settlementHistory: "结算历史",
    betSlipNumber: "投注单号",
    firstSettlementTime: "首次结算时间",
    lastSettlementTime: "最后结算时间",
    memberProfitLoss: "会员盈亏",
    jackpotContribution: "Jackpot贡献金额",
    jackpotPayout: "Jackpot派彩金额",
    eventName: "赛事名称",
    finalScore: "最终比分",
    singleItemStatus: "单项状态",
    settlementStatus: "结算状态",
    settlementCurrency: "结算币种",
    profitLossAmount: "盈亏金额",
    settlementReason: "结算原因",
    win: "赢",
    lose: "输",
    halfWin: "赢半",
    halfLose: "输半",
    push: "走水",
    cancelled: "已取消",
    pendingSettlement: "待结算",
    sportBetDetails: "体育注单详情",
    timeFilter: "时间筛选",
    dateRangeExceed32Days: "时间跨度不能超过32天",
    settleDateRangeExceed32Days: "结算时间跨度不能超过32天",
    selectBetTime: "请选择投注时间",
    loadDataFailed: "加载数据失败",
    collapse: "收起",
    expand: "展开",
    parlayCount: "{count}串1"
  },
 "betRecordHourlyList": {
    "title": "投注记录报表",
    "prompt": "凌晨4点跑前一天数据",
    "timeRange": "时间范围",
    "timeRangeRequired": "请选择时间范围",
    "memberAccount": "会员账号",
    "exportWarning": "请先输入查询条件",
    "notes": "说明：",
    "note1": "凌晨4点跑前一天数据",
    "note2": "当日的投注数据无法查询",
    "note3": "支持分页查看数据，用户可选择每页显示条数"
  },
  gamePlatformReport: {
    statisticsDate: "统计日期",
    platformType: "平台类型",
    platformName: "平台名称",
    platformKey: "平台标识",
    currency: "币种",
    betUsers: "投注用户数",
    betOrders: "投注单量",
    betAmount: "投注额",
    memberProfit: "会员盈亏",
    platformProfit: "平台盈亏",
    killRate: "杀率",
    killRateTooltip: "平台盈亏 / 投注额",
    rtp: "RTP",
    rtpTooltip: "1 - 杀率",
    ggr: "GGR",
    ggrTooltip: "投注 - 派彩",
    total: "合计",
    subGameName: "子游戏名称",
    enterPlatformName: "请输入平台名称",
    enterPlatformKey: "请输入平台标识",
    enterSubGameName: "请输入子游戏名称",
    all: "全部",
    today: "今天",
    yesterday: "昨天",
    thisWeek: "本周",
    thisMonth: "本月",
    lastMonth: "上月",
    last7Days: "最近7天",
    last30Days: "最近30天",
    totalRecords: "共 {total} 条",
    search: "查询",
    reset: "重置",
    date: "日期",
    noData: "暂无数据",
  },
  gameCodeReport: {
    title: "子游戏报表",
    prompt: "凌晨4点跑前一天数据",
    memberAccount: "会员账号",
    orderNumber: "订单号",
    statisticsDate: "统计日期",
    enterGameName: "请输入游戏名称",
    betNumber: "投注单号",
    gameName: "游戏名称",
    platformName: "平台名称",
    platformKey: "平台标识",
    currency: "币种",
    betUsers: "投注用户数",
    betOrders: "投注单量",
    betAmount: "投注额",
    memberProfit: "会员盈亏",
    platformProfit: "平台盈亏",
    killRate: "杀率",
    killRateTooltip: "平台盈亏 / 投注额",
    rtp: "RTP",
    rtpTooltip: "1 - 杀率",
    ggr: "GGR",
    ggrTooltip: "投注 - 派彩",
    total: "合计",
    subGameName: "子游戏名称",
    enterPlatformName: "请输入平台名称",
    enterPlatformKey: "请输入平台标识",
    enterSubGameName: "请输入子游戏名称",
    all: "全部",
    today: "今天",
    yesterday: "昨天",
    thisWeek: "本周",
    thisMonth: "本月",
    lastMonth: "上月",
    last7Days: "最近7天",
    last30Days: "最近30天",
    totalRecords: "共 {total} 条",
    search: "查询",
    reset: "重置",
    date: "日期",
    noData: "暂无数据",
  },
  depositReport: {
    title: "充值报表",
    date: "充值日期",
    currency: "币种",
    paymentChannel: "充值渠道",
    totalOrders: "总充值笔数",
    totalAmount: "总充值金额",
    totalSuccessOrders: "总充值成功笔数",
    totalPaySuccessAmount: "总充值成功金额",
    successRate: "成功率",
    thirdPartySuccessRate: "三方拉单成功率",
    depositDate: "充值日期",
    selectPaymentChannel: "请选择充值渠道",
    total: "合计",
    search: "查询",
    reset: "重置",
    all: "全部",
    totalRecords: "共 {total} 条",
    noData: "暂无数据",
    dateRange: {
      today: "今天",
      yesterday: "昨天",
      thisWeek: "本周",
      thisMonth: "本月",
      lastMonth: "上月",
      last7Days: "最近7天",
      last30Days: "最近30天"
    }
  },
  agentBonusStats: {
    title: "代理线优惠报表",
    dateRange: "时间范围",
    dateRangeRequired: "请选择时间范围",
    dateRangeExceeds3Months: "时间范围不能超过3个月",
    cannotQueryCurrentDay: "无法查询当日数据",
    agentAccount: "代理账号",
    agentAccountPlaceholder: "请输入代理账号",
    currency: "币种",
    currencyPlaceholder: "请选择币种",
    bonusName: "优惠名称",
    bonusNamePlaceholder: "请输入优惠名称",
    bonusType: "优惠类型",
    bonusTypePlaceholder: "请选择优惠类型",
    joinCount: "参与人数",
    bonusAmount: "派发金额",
    bonusPoint: "派发积分",
    day: "统计日期",
    cashTab: "现金",
    pointsTab: "积分",
    agentName: "代理名称",
    agentType: "代理类型",
    level1Agent: "一级代理",
    directAgent: "直属",
    level2Agent: "二级代理",
    summary: "汇总"
  },
  bonusRecordReport: {
    title: "优惠记录报表",
    prompt: "查询优惠派发记录",
    dateRange: "时间范围",
    dateRangeRequired: "请选择时间范围",
    dateRangeExceedsLimit: "时间范围不能超过7天",
    dateRangeExceeds3Months: "时间范围不能超过3个月",
    dateRangeExceeds6Months: "时间范围不能超过6个月",
    cannotQueryCurrentDay: "无法查询当日数据",
    pleaseEnterMemberAccount: "请输入要查询的会员账号",
    pleaseEnterSearchCriteria: "请输入至少一个搜索条件",
    currency: "币种",
    currencyPlaceholder: "请选择币种",
    bonusName: "优惠名称",
    bonusNamePlaceholder: "请输入优惠名称",
    bonusType: "优惠类型",
    bonusTypePlaceholder: "请选择优惠类型",
    "bonusType.monthlySalaryPoint": "月俸禄积分",
    "bonusType.weeklySalaryPoint": "周俸禄积分",
    "bonusType.birthdayPoint": "生日积分",
    joinCount: "参与人数",
    bonusAmount: "派发金额",
    bonusPoint: "派发积分",
    day: "统计日期",
    cashTab: "现金",
    pointsTab: "积分",
    status: "状态",
    completed: "已完成",
    pending: "未完成",
    memberAccount: "会员账号",
    memberAccountPlaceholder: "请输入会员账号"
  },
  withdrawReport: {
    title: "提款报表",
    withdrawDate: "提现日期",
    currency: "币种",
    withdrawChannel: "提现渠道",
    serialNumber: "序号",
    totalWithdrawCount: "总提款笔数",
    totalWithdrawAmount: "总提款金额",
    withdrawModel: "提现方式",
    withdrawFee: "提现手续费",
    successfulWithdrawCount: "成功提款笔数",
    successfulWithdrawAmount: "成功提款金额",
    withdrawSuccessRate: "提款成功率",
    manual: "手动",
    all: "全部",
    total: "合计",
    search: "查询",
    reset: "重置",
    export: "导出",
    totalRecords: "共 {total} 条",
    dateRangeRequired: "请选择日期范围",
    exporting: "正在导出，请稍候...",
    exportSuccess: "导出成功",
    exportFailed: "导出失败",
    today: "今天",
    yesterday: "昨天",
    thisWeek: "本周",
    thisMonth: "本月",
    lastMonth: "上月",
    last7Days: "最近7天",
    last30Days: "最近30天"
  },
  registrationConversionReport: {
    title: "注册与转换报表",
    dateRange: "日期范围",
    date: "日期",
    day: "日期",
    registerCount: "注册人数",
    registerFirstDepositCount: "注册首存人数",
    activeFirstDeposit: "活跃首存人数",
    registerFirstDepositRate: "注册首存转化率",
    totalFirstDepositRate: "总首存转化率",
    retentionCount: "续存人数",
    cumulativeDepositNumber: "累计充值笔数",
    cumulativeDepositAmount: "累计充值金额",
    search: "查询",
    reset: "重置",
    export: "导出",
    noData: "暂无数据",
    isAppUser: "请选择是否APP用户",
    selectAppUser: "请选择",
    yes: "是",
    no: "否",
    all: "全部",
    selectAgentType: "选择代理类型",
    selectAgentTypePlaceholder: "请选择",
    firstLevelAgent: "一级代理",
    secondLevelAgent: "二级代理",
    agentAccount: "请输入代理账号",
    enterAgentAccount: "请输入代理账号",
    agentTag: "代理标签",
    selectAgentTag: "请选择代理标签",
    query: "查询",
    report: "报表",
    chart: "图表",
    conversionRateChart: "首存转化率折线图",
    depositAmountChart: "累计充值金额折线图",
    noDataForChart: "暂无图表数据",
    selectTime: "选择时间",
    queryFailed: "查询失败",
    exportSuccess: "导出成功",
    exportFailed: "导出失败",
    items: "条",
    userStatistics: "注册与转换数据统计",
    table: "表格",
    dataTip: "数据提示",
    firstDepositCount: "活跃首存人数",
    firstDepositRate: "总首存转化率",
    coiledDepositCount: "续存人数",
    dateRangeExceeded: "日期范围不能超过31天",
    officialDirect: "官网直客"
  },
  valueStatsReport: {
    title: "价值报表",
    dateRange: "日期范围",
    date: "日期",
    registerCount: "注册人数",
    depositCount: "充值人数",
    depositAmount: "充值金额",
    withdrawAmount: "提现金额",
    firstDayLtv: "首日LTV",
    thirdDayLtv: "3日LTV",
    seventhDayLtv: "7日LTV",
    fifteenthDayLtv: "15日LTV",
    thirtiethDayLtv: "30日LTV",
    fortyFifthDayLtv: "45日LTV",
    sixtiethDayLtv: "60日LTV",
    seventyFifthDayLtv: "75日LTV",
    ninetiethDayLtv: "90日LTV",
    oneHundredFifthDayLtv: "105日LTV",
    oneHundredTwentiethDayLtv: "120日LTV",
    oneHundredThirtyFifthDayLtv: "135日LTV",
    oneHundredFiftiethDayLtv: "150日LTV",
    dailyArppu: "ARPPU",
    search: "查询",
    reset: "重置",
    export: "导出",
    noData: "暂无数据",
    isAppUser: "请选择是否APP用户",
    selectAppUser: "请选择",
    yes: "是",
    no: "否",
    all: "全部",
    selectAgentType: "选择代理类型",
    selectAgentTypePlaceholder: "请选择",
    firstLevelAgent: "一级代理",
    secondLevelAgent: "二级代理",
    agentAccount: "请输入代理账号",
    enterAgentAccount: "请输入代理账号",
    agentTag: "代理标签",
    selectAgentTag: "请选择代理标签",
    query: "查询",
    report: "报表",
    chart: "图表",
    selectTime: "选择时间",
    queryFailed: "查询失败",
    exportSuccess: "导出成功",
    exportFailed: "导出失败",
    selectCurrency: "请选择币种",
    items: "条",
    chartComingSoon: "图表功能即将上线",
    dateRangeExceeded: "日期范围不能超过31天",
    officialDirect: "官网直客"
  },
  keepStatsReport: {
    title: "存款留存报表",
    dateRange: "日期范围",
    date: "日期",
    day: "日期",
    registerCount: "注册人数",
    memberLoginCount: "登录人数",
    firstDepositCount: "注册首充人数",
    firstDepositRate: "注册首存率",
    registerFirstDepositCount: "注册首充人数",
    totalFirstDepositRate: "总首存率",
    activeFirstDepositCount: "活跃首存人数",
    activeFirstDepositRate: "活跃首存率",
    coiledDepositCount: "当日续存人数",
    coiledDepositRate: "当日续存率",
    firstDayRetention: "第1日续存",
    firstDayRetentionTooltip: "第1日存款续存人数/比率",
    tomorrowKept: "第2日留存",
    tomorrowKeptTooltip: "第2日存款留存人数/比率",
    tomorrowKeptRate: "次日留存率",
    threeKept: "第3日留存",
    threeKeptTooltip: "第3日存款留存人数/比率",
    threeKeptRate: "3日留存率",
    fourKept: "第4日留存",
    fourKeptTooltip: "第4日存款留存人数/比率",
    fourKeptRate: "4日留存率",
    fiveKept: "第5日留存",
    fiveKeptTooltip: "第5日存款留存人数/比率",
    fiveKeptRate: "5日留存率",
    sixKept: "第6日留存",
    sixKeptTooltip: "第6日存款留存人数/比率",
    sixKeptRate: "6日留存率",
    sevenKept: "第7日留存",
    sevenKeptTooltip: "第7日存款留存人数/比率",
    sevenKeptRate: "7日留存率",
    fifteenKept: "第15日留存",
    fifteenKeptTooltip: "第15日存款留存人数/比率",
    fifteenKeptRate: "15日留存率",
    thirtyKept: "第30日留存",
    thirtyKeptTooltip: "第30日存款留存人数/比率",
    thirtyKeptRate: "30日留存率",
    thirtyCoiledDepositCount: "30日复存人数",
    thirtyCoiledDepositRate: "30日复存率",
    dailyCoiledDepositRate: "当日续存率",
    thirtyCoiledDepositDetail: "30日复存明细",
    search: "查询",
    reset: "重置",
    export: "导出",
    noData: "暂无数据",
    isAppUser: "请选择是否APP用户",
    selectAppUser: "请选择",
    yes: "是",
    no: "否",
    all: "全部",
    selectAgentType: "选择代理类型",
    selectAgentTypePlaceholder: "请选择",
    firstLevelAgent: "一级代理",
    secondLevelAgent: "二级代理",
    agentAccount: "请输入代理账号",
    enterAgentAccount: "请输入代理账号",
    agentTag: "代理标签",
    selectAgentTag: "请选择代理标签",
    query: "查询",
    selectTime: "选择时间",
    queryFailed: "查询失败",
    exportSuccess: "导出成功",
    exportFailed: "导出失败",
    selectCurrency: "请选择币种",
    items: "条",
    report: "报表",
    chart: "图表",
    retentionChart: "留存数据图表",
    noDataForChart: "暂无图表数据",
    retentionCount: "留存人数",
    userStatistics: "留存数据统计",
    table: "表格",
    dataTip: "数据提示",
    dateRangeExceeded: "日期范围不能超过31天",
    modalDescription: "此数据表示在指定日期注册的用户中，在注册后首次进行存款的用户数量。活跃首存率 = 活跃首存人数 / 注册人数 × 100%",
    officialDirect: "官网直客"
  },
  betKeepStatsReport: {
    title: "投注留存报表",
    dateRange: "日期范围",
    day: "日期",
    registerCount: "注册人数",
    firstBetCount: "注册首投人数",
    firstBetRate: "注册首投率",
    delayFirstBetCount: "活跃首投人数",
    totalFirstBetRate: "总首投率",
    activeFirstBetRate: "活跃首投率",
    thirtyRebetCount: "30日复投人数",
    thirtyRebetCountTooltip: "注册首投用户在30日内再次投注的去重用户数",
    thirtyRebetRate: "30日复投率",
    thirtyRebetRateTooltip: "30日复投人数 / 注册首投人数",
    firstDayBet: "第1日续投",
    firstDayBetTooltip: "D0首投用户中当天再次投注的人数/比率",
    tomorrowBet: "第2日投注",
    tomorrowBetTooltip: "注册首投用户在注册次日投注的人数/比率（D1）",
    threeBet: "第3日投注",
    threeBetTooltip: "第3日投注留存人数/比率（D2）",
    fourBet: "第4日投注",
    fourBetTooltip: "第4日投注留存人数/比率（D3）",
    fiveBet: "第5日投注",
    fiveBetTooltip: "第5日投注留存人数/比率（D4）",
    sixBet: "第6日投注",
    sixBetTooltip: "第6日投注留存人数/比率（D5）",
    sevenBet: "第7日投注",
    sevenBetTooltip: "第7日投注留存人数/比率（D6）",
    fifteenBet: "第15日投注",
    fifteenBetTooltip: "第15日投注留存人数/比率（D14）",
    thirtyBet: "第30日投注",
    thirtyBetTooltip: "第30日投注留存人数/比率（D29）",
    isAppUser: "请选择是否APP用户",
    selectAppUser: "请选择",
    yes: "是",
    no: "否",
    all: "全部",
    selectAgentType: "选择代理类型",
    selectAgentTypePlaceholder: "请选择",
    agentAccount: "代理账号",
    enterAgentAccount: "请输入代理账号",
    agentTag: "代理标签",
    selectAgentTag: "请选择代理标签",
    query: "查询",
    export: "导出",
    reset: "重置",
    noData: "暂无数据",
    userStatistics: "投注留存统计",
    table: "表格",
    dateRangeExceeded: "日期范围不能超过31天",
    officialDirect: "官网直客",
    thirtyRebetDetail: "30日复投明细"
  },
  delayFirstDeposit: {
    title: "延迟首存历史",
    description: "注册日期",
    memberAccount: "会员账号",
    registerTime: "注册时间",
    firstDepositTime: "首存时间",
    firstDepositAmount: "首存金额",
    agentAccount: "代理账号",
  },
  overviewStatsReport: {
    title: "总览报表",
    summary: "总览统计",
    dateRange: "日期范围",
    date: "日期",
    day: "日期",
    loginCount: "登录人数",
    registerCount: "注册数",
    memberLoginCount: "登录人数",
    firstDepositCount: "首存数",
    firstDepositRate: "首存转化率",
    depositAmount: "总充值金额",
    withdrawAmount: "总提现金额",
    profitAndLoss: "出入款盈亏",
    registerFirstDepositCount: "注册首存",
    activeFirstDepositCount: "活跃首存",
    registerFirstDepositRate: "注册首存转化率",
    totalFirstDepositRate: "总首存转化率",
    tomorrowRetention: "次日留存",
    sevenDayRetention: "7日留存",
    thirtyDayRetention: "30日留存",
    firstDayLTV: "LTV（首日）",
    thirtyDayLTV: "LTV（30日）",
    search: "查询",
    reset: "重置",
    report: "报表",
    chart: "图表",
    overviewChart: "总览数据图表",
    noDataForChart: "暂无图表数据",
    queryFailed: "查询失败",
    noData: "暂无数据",
    items: "条",
    export: "导出",
    exportSuccess: "导出成功",
    exportFailed: "导出失败",
    isAppUser: "请选择是否APP用户",
    selectAppUser: "请选择",
    yes: "是",
    no: "否",
    all: "全部",
    selectAgentType: "选择代理类型",
    selectAgentTypePlaceholder: "请选择",
    firstLevelAgent: "一级代理",
    secondLevelAgent: "二级代理",
    agentAccount: "请输入代理账号",
    enterAgentAccount: "请输入代理账号",
    agentTag: "代理标签",
    selectAgentTag: "请选择代理标签",
    query: "查询",
    selectTime: "选择时间",
    selectCurrency: "请选择币种",
    userStatistics: "总览数据统计",
    officialDirect: "官网直客",
    table: "表格",
    dataTip: "数据提示",
    dateRangeExceeded: "日期范围不能超过31天"
  },
  memberLoginLogReport: {
    title: "会员登录日志报表",
    dateRange: "登录时间",
    date: "日期",
    day: "日期",
    registerCount: "注册人数",
    depositCount: "充值人数",
    loginIp: "登入IP",
    loginDeviceId: "登录设备ID",
    ipLocation: "IP归属地",
    loginMethod: "登录方式",
    loginChannel: "登录终端",
    memberAccount: "登录账号",
    enterMemberAccount: "请输入登录账号",
    enterLoginIp: "请输入登入ip",
    enterIpLocation: "请输入ip所在地",
    enterLoginMethod: "请输入登录方式",
    enterLoginChannel: "请输入登录终端",
    all: "全部",
    loginDomain: "登录域名",
    unknownLocation: "未知",
    loginChannels: {
      all: "全部",
      others: "其他",
      web: "Web",
      androidApp: "Android APP",
      androidH5: "Android H5",
      androidPwa: "Android PWA",
      iosH5: "iOS H5",
      iosPwa: "iOS PWA",
      iosApp: "IOS APP"
    },
    loginMethods: {
      all: "全部",
      password: "账号密码",
      facebook: "Facebook",
      google: "Google",
      apple: "Apple"
    },
  },
  memberLoginLogSummary: {
    title: "会员登录日志汇总",
    dateRange: "日期范围",
    date: "日期",
    day: "日期",
    registerCount: "注册人数",
    depositCount: "充值人数",
  },
  onlineUserPanel: {
    title: "在线用户面板",
    currentOnlineUsers: "当前在线人数",
    currentOnlineUsersDesc: "统计包含：最近30分钟内登录、进入游戏页面、进入存提款页面、在个人中心进行操作的用户",
    realtimeOnlineChart: "实时在线人数 (同一时段三日环比)",
    mobileProviderDistribution: "运营商分布",
    deviceDistribution: "设备分布",
    regionDistribution: "地区分布",
    regionList: "地区分布",
    onlineUserList: "在线用户列表",
    labels: {
      unknown: "未知",
      noData: "暂无数据",
      noCityData: "暂无城市数据",
    },
    actionTypes: {
      login: "登录",
      logout: "登出",
      enterGame: "进入游戏",
      depositPage: "存款页面",
      withdrawPage: "提款页面",
      personalCenter: "个人中心",
    },
    regionTable: {
      country: "国家",
      province: "省份",
      city: "城市",
      total: "人数",
      all: "全部",
    },
    table: {
      memberAccount: "会员账号",
      lastActionTime: "最后行为时间",
      actionType: "行为类型",
      deviceType: "设备类型",
      totalRecords: "当前共 {total} 条记录",
    },
  },
  payOrderStat: {
    title: "充值看板",
    selectCurrency: "选择币种",
    orderOverview: "订单总览",
    rechargeAmount: "充值金额",
    withdrawAmount: "提现金额",
    payWithdrawDiff: "充提差",
    statistics: "统计数据",
    totalPayCount: "总充值笔数",
    successRate: "充值成功率",
    avgPayTime: "平均充值到账时间",
    successCount: "充值成功",
    failedCount: "充值失败",
    pendingCount: "待处理",
    channelTitle: "充值方式",
    selectChannel: "选择充值方式",
    channelTotalPayCount: "总充值笔数",
    channelAvgPayTime: "平均充值到账时间",
    channelSuccessCount: "充值成功",
    channelFailedCount: "充值失败",
    channelPendingCount: "待处理",
    fetchFailed: "获取充值看板统计失败",
    channelFetchFailed: "获取充值方式看板统计失败",
  },
  withdrawOrderStat: {
    title: "提现看板",
    selectCurrency: "选择币种",
    orderOverview: "订单总览",
    rechargeAmount: "充值金额",
    withdrawAmount: "提现金额",
    payWithdrawDiff: "充提差",
    statistics: "统计数据",
    totalWithdrawCount: "总提现笔数",
    successRate: "提现成功率",
    avgWithdrawTime: "平均提现时间",
    avgRiskCheckTime: "平均审核时间",
    avgRiskCheckTimeTooltip: "人工审核订单",
    successCount: "已出款",
    refusedCount: "已拒绝",
    pendingPayoutCount: "待出款",
    pendingReviewCount: "待审核",
    pendingReviewCountTooltip: "人工审核订单",
    channelTitle: "提现方式",
    selectChannel: "选择提现方式",
    channelTotalWithdrawCount: "总提现笔数",
    channelAvgWithdrawTime: "平均提现时间",
    channelAvgRiskCheckTime: "平均审核时间",
    channelSuccessCount: "已出款",
    channelRefusedCount: "已拒绝",
    channelPendingPayoutCount: "待出款",
    channelPendingReviewCount: "待审核",
    fetchFailed: "获取提现看板统计失败",
    channelFetchFailed: "获取提现方式看板统计失败",
  },
  crossDayTransferSettlement: {
    title: "跨日报转结分析看板",
    keyIndicators: "关键指标",
    selectDate: "选择日期时间",
    yesterdayUnsettledCount: "昨日未结算注单数",
    todayCompletedTransferCount: "今日完成转结结算",
    todayRemainingUnsettledCount: "今日仍未结算昨日注单",
    todaySecondSettlementCount: "今日发生二次结算的转结注单数",
    profitLossChange: "盈亏变动 (重复结算)",
    repeatSettlementRatio: "重复结算占比",
  },
  jeepneyFunnelAnalysis: {
    title: "裂变漏斗分析",
    statisticsDate: "统计日期",
    dateSelect: "日期选择",
    fixedForToday: "固定当天的",
    dateRange: "日期范围",
    funnelChart: "漏斗图",
    funnelTable: "漏斗表（按事件链路）",
    metricCards: "指标卡",
    step: "步骤",
    event: "事件",
    userCountUV: "人数（UV）",
    dimension: "维度",
    enterActivity: "进入活动主界面",
    clickAdvance: "点击推进（至少1次）",
    insufficientCurrency: "触发货币不足拦截（至少1次）",
    openCurrencyPopup: "打开货币获取弹窗（至少1次）",
    completeCurrencyAcquire: "完成货币获取（至少1次）",
    reachFinalStage: "到达最终关",
    settlementSuccess: "结算成功",
    settlementFailure: "结算失败",
    settlementResult: "结算结果（成功/失败）",
    activityParticipation: "活动参与",
    rechargeUsers: "充值人数",
    exchangeUsers: "兑换人数",
    inviteValidFriends: "邀请有效好友人数",
    conversionRate: "转化率",
    noData: "暂无数据"
  }

};
